export default __webpack_public_path__ + "static/media/aspect_ratio_control_dark_icon.7c87dff3.svg";